import { render, staticRenderFns } from "./InventoryItem.vue?vue&type=template&id=4a94398a&scoped=true&"
import script from "./InventoryItem.vue?vue&type=script&lang=js&"
export * from "./InventoryItem.vue?vue&type=script&lang=js&"
import style0 from "./InventoryItem.vue?vue&type=style&index=0&id=4a94398a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a94398a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VDataTable,VIcon,VProgressLinear,VSelect})
